import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../services/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  // Debug bilgisi
  useEffect(() => {
    console.log("ProtectedRoute çalıştı");
    console.log("Geçerli yol:", location.pathname);
    console.log("Kimlik doğrulama durumu:", isAuthenticated);
  }, [location.pathname, isAuthenticated]);

  if (!isAuthenticated) {
    // Giriş yapmamış kullanıcıyı login sayfasına yönlendir
    console.log("Kimlik doğrulanmadı, yönlendiriliyor: /auth/login");
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
